import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { getDatepickerConfig } from '@app/app.helper';

import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';

import { BackButtonComponent } from './back-button/back-button.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { LoaderComponent } from './loader/loader.component';
import { ModalComponent } from './modal/modal.component';
import { PagetitleComponent } from './pagetitle/pagetitle.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { ConfirmDeleteAllAlertComponent } from './confirm-delete-all-alert/confirm-delete-all-alert.component';
import { GridPaginationComponent } from './grid/pagination/grid-pagination.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';

@NgModule({
  declarations: [PagetitleComponent, LoaderComponent, BackButtonComponent, BreadcrumbsComponent, ModalComponent, ConfirmDeleteAllAlertComponent, GridPaginationComponent, FileUploaderComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    BsDropdownModule.forRoot(),
    SweetAlert2Module.forRoot(),
    PaginationModule.forRoot()
  ],
  exports: [PagetitleComponent, LoaderComponent, BackButtonComponent, BreadcrumbsComponent, ModalComponent, ConfirmDeleteAllAlertComponent, GridPaginationComponent, FileUploaderComponent],
  providers: [{ provide: BsDatepickerConfig, useFactory: getDatepickerConfig }]
})
export class UIModule {
}
